import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../../lib/brand";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="wrap footer-grid">
        <div className="footer-brand">
          <Logo testId="footer-brand-link" compact />
          <p>Government-approved fire trucks, emergency vehicles and firefighting equipment — engineered in New Delhi.</p>
        </div>
        <div>
          <h4>Explore</h4>
          {[["/products", "Product catalog"], ["/vehicles", "Fire vehicles"], ["/tenders", "GeM & tenders"], ["/services", "Services"], ["/contact", "Contact"]].map(([to, l]) => <Link key={to} to={to} data-testid={`footer-link-${to.slice(1)}`}>{l}</Link>)}
        </div>
        <div>
          <h4>Reach us</h4>
          <a href={CONTACT.tel} data-testid="footer-phone-link"><Phone size={14} /> {CONTACT.phone}</a>
          <a href={`mailto:${CONTACT.info}`} data-testid="footer-info-email"><Mail size={14} /> {CONTACT.info}</a>
          <a href={`mailto:${CONTACT.sales}`} data-testid="footer-sales-email"><Mail size={14} /> {CONTACT.sales}</a>
          <span className="footer-address"><MapPin size={14} /> Bakarwala, New Delhi – 110041</span>
        </div>
      </div>
      <div className="wrap footer-bottom">
        <span>© 2026 ML FAB Enterprises Private Limited · GSTIN 07AAVCM0217D1ZM</span>
        <Link to="/admin" data-testid="admin-login-link">Admin login</Link>
      </div>
    </footer>
  );
}
